import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  getToken(): string {
    return localStorage.getItem('webpay-token');
  }

  setToken(token: string): void {
    localStorage.setItem('webpay-token', token);
  }

  removeTokenFromLocalStorage(): void {
    localStorage.removeItem('webpay-token');
  }
}
